/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';

class InlineInput extends Component {
    render() {
        let {
            value,
            onChange,
            placeholder = "---",
            className = "",
            innerRef,
            onClick,
            onFocus,
            style = {},
            onKeyDown
        } = this.props

        return (
            <input type={"empty"} value={value}
                   placeholder={placeholder}
                   ref={innerRef}
                   onClick={(event) => {
                       event.preventDefault()
                       event.stopPropagation()
                       if (onClick !== undefined) {
                           onClick()

                       }
                   }}
                   style={style}
                   className={`text-base h-10 bg-stone-100 w-full rounded outline-none focus:ring-blue-300   focus:border-blue-300 hover:border-gray-400 focus:ring-inset p-3 border border-transparent placeholder:opacity-25 ${className}`}
                   onChange={(event) => {
                       if (onChange !== undefined) {
                           onChange(event.target.value)
                       }
                   }}
                   onKeyDown={(event) => {
                       if (onKeyDown !== undefined) {
                           onKeyDown(event)
                       }
                   }}
                   onFocus={(event) => {
                       if (onFocus !== undefined) {
                           onFocus(event)
                       }
                   }}
            />
        );
    }
}

InlineInput.propTypes = {};

export default InlineInput;